/**
 * platform — detección de la app nativa (wrapper Capacitor), s63 (S-3).
 *
 * `isNativeApp()` = true SOLO dentro del wrapper iOS/Android (Capacitor
 * inyecta su runtime); false en web y PWA. Úsalo para diferencias de
 * shell (viewport, OAuth) — nunca para lógica de negocio.
 */
import { Capacitor } from "@capacitor/core";

export function isNativeApp(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}
